export default {
    meta: {
        title: '线索详情',
        isShowNav: true,
        activeMenu: '/clue',
    },
};
